import { getGlobalHistory } from 'app/services/history';
import { createGuid } from 'app/types/guid';

interface IStore {
  [key: string]: { data: unknown, release: () => void };
}
const flashStore: IStore = {};

export function setFlash(data: any): string {
  const key = createGuid();
  const deferrer = getGlobalHistory().deferReloadOnNavigate();
  flashStore[key] = { data, release: deferrer };
  return key;
}

export function getFlash(key: string): unknown {
  const entry = flashStore[key];
  if (entry) {
    const { data, release } = flashStore[key];
    delete flashStore[key];
    release();
    return data;
  }
  return undefined;
}
